import { render, staticRenderFns } from "./NCurrencyInput.vue?vue&type=template&id=32861ed4&scoped=true&"
import script from "./NCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./NCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32861ed4",
  null
  
)

export default component.exports